import React from 'react'

import dayjs from 'dayjs'

import { Typography } from '../typography/typography'

export const UsageHistoryDateHeader = ({
  from,
  to,
}: {
  from: string
  to: string
}) => {
  const fromDate = dayjs(from)
  const toDate = dayjs(to)
  const yearMaybe = fromDate.year() === toDate.year() ? '' : ' YYYY'
  const fromText = fromDate.format(`MMM Do${yearMaybe}`)
  const toText = toDate.format('MMM Do YYYY')

  return (
    <Typography
      variant="Kollektif/MediumEmphasis"
      data-testid="usage-history-date-range"
    >
      {`${fromText}–${toText}`}
    </Typography>
  )
}

export default UsageHistoryDateHeader
